// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dtc-modal {
  .header {
    .title {
      margin: unset;
    }

    .close {
      top: 10px !important;
      right: 14px !important;
    }
  }

  .product_price {
    padding-bottom: 36px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dialog/BuyboxDialog/styles.css"],"names":[],"mappings":"AAAA;EACE;IACE;MACE,aAAa;IACf;;IAEA;MACE,oBAAoB;MACpB,sBAAsB;IACxB;EACF;;EAEA;IACE,+BAA+B;EACjC;AACF","sourcesContent":[".dtc-modal {\n  .header {\n    .title {\n      margin: unset;\n    }\n\n    .close {\n      top: 10px !important;\n      right: 14px !important;\n    }\n  }\n\n  .product_price {\n    padding-bottom: 36px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
